"use client";

import { useQuery } from "@tanstack/react-query";
import { Keys } from "@/api/AppApi/common-interfaces/quiries-keys/keysValues";
import { getKey } from "@/api/AppApi/common-interfaces/quiries-keys/queries-keys";
import { apiConfig } from "@/api/AppApi/config";
import { getAccessToken } from "@/utils/functions/cookieOperations";
import ApiOrder from "./api-order";

export function usePopupOrderCount(enabled: boolean) {
  return useQuery(
    // Keep the orders prefix so successful checkout invalidates this check too.
    [
      ...getKey(Keys.get_all_orders),
      "popup-count",
      typeof window === "undefined" ? "" : window.location.host,
      getAccessToken(),
    ],
    () => new ApiOrder(apiConfig()).getPopupOrderCount(),
    { enabled, retry: false, refetchOnWindowFocus: false, staleTime: 0 },
  );
}
